import {white, airBlue} from '@modifi/colors'
import {Highlight} from '@modifi/ui'
import styled, {css, keyframes} from 'styled-components'

export const FlippableWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  max-width: 1200px;
  margin: 0 auto;
`

export const FlippableCardContainer = styled.div`
  width: 240px;
  height: 240px;
  margin: 16px;
`

const flip180 = keyframes`
  0% {
    transform: rotateY(0);
  }

  100% {
    transform: rotateY(180deg);
  }
`

const flip180Back = keyframes`
  0% {
    transform: rotateY(180deg);
  }

  100% {
    transform: rotateY(0);
  }
`

const animationFlip = css`
  animation-name: ${flip180};
`

const animationFlipBack = css`
  animation-name: ${flip180Back};
`

type FlipCardProps = {
  isCardFlipped: boolean
}

export const FlipCard = styled.div<FlipCardProps>`
  position: relative;
  width: 100%;
  height: 100%;
  transform-style: preserve-3d;
  transition: all 1s;
  border-radius: 16px;
  perspective: 150rem;
  ${({isCardFlipped}): any => (isCardFlipped ? animationFlip : animationFlipBack)}
  animation-fill-mode: forwards;
  animation-duration: 1s;

  img {
    max-width: 70px;
  }
`

const commonCardFaceStyles = css`
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: initial;
  box-shadow: 3px 4px 16px rgba(23, 61, 108, 0.12);
`

export const CardFront = styled.div`
  ${commonCardFaceStyles}
  background-color: ${white};
  display: flex;
  flex-direction: column;
`

export const CardBack = styled(Highlight)`
  ${commonCardFaceStyles}
  transform: rotateY(180deg);
  padding: 16px;
  text-align: center;
  background-color: ${airBlue};
  color: ${white};
`
